import { ImageProps, ImageSource } from 'expo-image'
import React, { useMemo } from 'react'

type Props = {
  source: ImageSource
  style: ImageProps['style']
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement>) => void
}

function WebImage({ source, onLoad, style = [] }: Props): React.JSX.Element | null {
  const uri = source?.uri || null

  const styled = useMemo(() => {
    return Array.isArray(style)
      ? style.flat().reduce(
          (accumulator, current) => {
            Object.assign(accumulator, current)
            return accumulator
          },
          Object.assign({}, {}),
        )
      : {}
  }, [style])

  if (!uri) {
    return null
  }

  return <img src={uri || undefined} key={uri} onLoad={onLoad} style={styled} draggable={false} />
}

export default WebImage
